module.exports = __webpack_public_path__ + "img/home-selling-point4.9c9ffb62.png";